var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",null,{"day":_vm.day,"hour":_vm.hour,"min":_vm.min,"sec":_vm.sec}),_c('p',[(_vm.day != '00')?_c('span',[_vm._v(_vm._s(_vm.day)+"d")]):_vm._e(),_vm._v(" "+_vm._s(_vm.hour)+"h "+_vm._s(_vm.min)+"m "+_vm._s(_vm.sec)+"s")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }